// import Image from "next/image";
import dynamic from "next/dynamic";
const Breadcrumb = dynamic(() => import("@/Components/Breadcrumb/Breadcrumb"), {
  ssr: true,
});

interface BannerProps {
  data: any;
  slug: string;
  title: string;
  breadcrumbs?: any;
}

const Banner: React.FC<BannerProps> = ({ data, breadcrumbs }) => {
  return (
    <section className="relative bg-background-dark text-white pt-32 pb-20 overflow-hidden">
      {/* Background Decorations */}
      {/* <Image
        src="/images/consulting/banner-top.png"
        width={500}
        height={500}
        alt="banner-top"
        className="absolute top-[-80px] left-0"
      />
      <Image
        src="/images/consulting/banner-bottom.png"
        width={400}
        height={400}
        alt="banner-bottom"
        className="absolute bottom-0 right-0"
      /> */}

      {/* Content */}
      <div className="container mx-auto px-4 text-center relative z-10">
        {breadcrumbs?.item?.length > 0 && (
          <Breadcrumb
            items={breadcrumbs?.item ?? []}
            className="mb-6 text-gray-300 flex justify-center"
          />
        )}

        <h1 className="text-display font-extrabold mx-auto text-center text-primary-text-white uppercase max-w-[1230px] mb-[16px]">
          {data.title}
        </h1>

        {/* Banner Images */}
        {/* Description */}
        <p className="text-secondary-text-white text-subtitle-2  mb-2 max-w-[870px] mx-auto whitespace-pre-line">
          {data?.description ?? ""}
        </p>
      </div>
    </section>
  );
};

export default Banner;
